<template>
  <div class="off-screens">
    <!-- Snackbar -->
    <snackbar />
  </div>
</template>

<script>
// deps
import { mapGetters } from 'vuex'
// ui
import Snackbar from '@/components/ui/Snackbar'
// export
export default {
  // name
  name: 'OffScreens',
  // components
  components: {
    snackbar: Snackbar
  },
  // computed
  computed: {
    // mapGetters
    ...mapGetters([])
  }
}
</script>
